import React, { useState } from "react";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { ASSETS } from "../../utils/config";
import Typography from "@mui/material/Typography";
import "../TimedWheel/timedwheel.scss";
import CloseIcon from "@mui/icons-material/Close";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import ModalBody from "../../pages/WheelView/ModalContent/ModalBody";
import VideoPreviewModal from "../VideoPreviewModal";
import ImagePreviewModal from "../ImagePreviewModal";
import AudioPreviewModal from "../AudioPreviewModal";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import "./styles.css";
import { Box } from "@material-ui/core";
import YoutubeVideoPreviewModal from "../MediaBrowser/YoutubeVideoPreviewModal";
import { colors } from "../../utils";
import { TextView } from "..";

const RenderMedia = ({
  isViewMediaOpen,
  toggleViewMediaOpen,
  images,
  videos,
  audios,
  documents,
  toggleHotbarOpen,
}) => {
  const [openPreviewVideo, setOpenPreviewVideo] = useState(false);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const pattern = /^(https?:\/\/)?(www\.youtube\.com|youtu\.?be)\/.+$/;

  const [openYoutubePreviewVideo, setOpenYoutubePreviewVideo] =
    React.useState(false);
  const [selectedYoutubeVideo, setSelectedYoutubeVideo] = React.useState(null);

  const handleOpenYoutubePreviewVideo = (src) => {
    setSelectedYoutubeVideo(src);
    setOpenYoutubePreviewVideo(true);
  };

  const handleClosePreviewYoutubeVideo = () => {
    setOpenYoutubePreviewVideo(false);
  };

  const handleOpenPreviewVideo = (url) => {
    setSelectedVideo(url);
    setOpenPreviewVideo(true);
  };

  const handleClosePreviewVideo = () => {
    setOpenPreviewVideo(false);
  };

  const [openPreviewImage, setOpenPreviewImage] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const handleOpenPreviewImage = (url) => {
    setSelectedImage(url);
    setOpenPreviewImage(true);
  };

  const handleClosePreviewImage = () => {
    setOpenPreviewImage(false);
  };

  const [openPreviewAudio, setOpenPreviewAudio] = useState(false);
  const [selectedAudio, setSelectedAudio] = useState(null);

  const handleOpenPreviewAudio = (url) => {
    setSelectedAudio(url);
    setOpenPreviewAudio(true);
  };

  const handleClosePreviewAudio = () => {
    setOpenPreviewAudio(false);
  };

  const CustomRightArrow = ({ onClick, ...rest }) => {
    const {
      onMove,
      carouselState: { currentSlide, deviceType },
    } = rest;
    return (
      <Box
        onClick={() => onClick()}
        style={{
          zIndex: "1000",
          height: "20px",
          width: "20px",
          borderRadius: "10px",
          backgroundColor: "rgba(0,0,0,0.3)",
          position: "absolute",
          right: "0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          cursor: "pointer",
        }}
      >
        <ChevronRightIcon style={{ fontSize: "14px", color: "white" }} />
      </Box>
    );
  };

  const CustomLeftArrow = ({ onClick, ...rest }) => {
    const {
      onMove,
      carouselState: { currentSlide, deviceType },
    } = rest;
    return (
      <Box
        onClick={() => onClick()}
        style={{
          zIndex: "1000",
          height: "20px",
          width: "20px",
          borderRadius: "10px",
          backgroundColor: "rgba(0,0,0,0.3)",
          position: "absolute",
          left: "0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          cursor: "pointer",
        }}
      >
        <ChevronLeftIcon style={{ fontSize: "14px", color: "white" }} />
      </Box>
    );
  };

  function getYoutubeThumbnailUrl(videoUrl) {
    // Extract the video ID from the YouTube URL
    const videoIdMatch = videoUrl.match(
      /(?:youtu\.be\/|youtube\.com(?:\/embed\/|\/v\/|\/watch\?v=|\/watch\?.+&v=))([^\s&]+)/
    );
    if (videoIdMatch) {
      const videoId = videoIdMatch[1];
      // Construct the thumbnail URL
      return `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;
    } else {
      return null; // Return null if the video ID couldn't be extracted
    }
  }

  return (
    <>
      <div
        style={{
          width: "17vw",
          backgroundColor: "white",
          borderRadius: "20px",
          padding: "10px",
          marginTop: 10,
        }}
      >
        {isViewMediaOpen && (
          <div
            onClick={toggleViewMediaOpen}
            style={{
              height: 28,
              width: 20,
              borderRadius: 5,
              backgroundColor: colors.primary,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              position: "absolute",
              marginTop: 0,
              marginLeft: -20,
              cursor: "pointer",
              zIndex: 100,
            }}
          >
            <ChevronRightIcon fontSize="medium" style={{ color: "white" }} />
          </div>
        )}
        <div className="hotbar-header">
          <div className="hotbar-header-left">
            <img
              className="hotbar-icon"
              src={ASSETS.viewMediaIcon}
              alt="icon"
            />

            <TextView style={{ marginLeft: 5 }} variant="title">
              Media
            </TextView>
          </div>
          <div onClick={toggleHotbarOpen}>
            <img
              className="hotbar-right-icon"
              alt="hotbarlogo"
              src={ASSETS.hotbarIcon}
            />
          </div>
        </div>
        <div
          style={{
            backgroundColor: "#f6f7f9",
            margin: "5px",
            padding: "10px",
            borderRadius: "10px",
          }}
        >
          <Typography
            variant="subtitle1"
            component="subtitle1"
            style={{
              fontFamily: "DM Sans",
              fontWeight: "500",
              fontSize: "10px",
            }}
          >
            Images
          </Typography>

          <Carousel
            customLeftArrow={<CustomLeftArrow />}
            customRightArrow={<CustomRightArrow />}
            responsive={{
              superLargeDesktop: {
                // the naming can be any, depends on you.
                breakpoint: { max: 4000, min: 3000 },
                items: 3,
              },
              desktop: {
                breakpoint: { max: 3000, min: 1024 },
                items: 4,
              },
            }}
          >
            {images?.length > 0 ? (
              images.map((data) => (
                <div
                  style={{
                    cursor: "pointer",
                    marginLeft: "4px",
                    marginRight: "4px",
                    width: "35px",
                    height: "35px",
                    borderRadius: "8px",
                    backgroundImage: `url(${data})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat", // This ensures the image doesn't tile.
                  }}
                  onClick={() => handleOpenPreviewImage(data)}
                >
                  {/* <img
                    alt="mediaImages"
                    style={{
                      width: "35px",
                      height: "35px",
                      borderRadius: "8px",
                      objectFit: "contain", // Ensures the image covers the area without warping
                      objectPosition: "center", // Centers the image within the element
                    }}
                    src={data}
                  /> */}
                </div>
              ))
            ) : (
              <div style={{ fontSize: "8px", fontFamily: "DM Sans" }}>
                Not found
              </div>
            )}
          </Carousel>

          <div style={{ paddingTop: "5px" }}>
            <Typography
              variant="subtitle1"
              component="subtitle1"
              style={{
                fontFamily: "DM Sans",
                fontWeight: "500",
                fontSize: "10px",
              }}
            >
              Videos
            </Typography>
          </div>

          <Carousel
            customLeftArrow={<CustomLeftArrow />}
            customRightArrow={<CustomRightArrow />}
            responsive={{
              superLargeDesktop: {
                breakpoint: { max: 4000, min: 3000 },
                items: 5,
              },
              desktop: { breakpoint: { max: 3000, min: 1024 }, items: 3 },
            }}
          >
            {videos?.length > 0 ? (
              videos.map((videoUrl) => (
                <div
                  style={{
                    position: "relative",
                    overflow: "hidden",
                    width: "44px",
                    height: "31px",
                    borderRadius: "8px",
                    cursor: "pointer",
                    marginLeft: "4px",
                    marginRight: "4px",
                  }}
                  // onClick={() => handleOpenPreviewVideo(videoUrl)}
                  onClick={() => {
                    pattern.test(videoUrl)
                      ? handleOpenYoutubePreviewVideo(videoUrl)
                      : handleOpenPreviewVideo(videoUrl);
                  }}
                >
                  {pattern.test(videoUrl) ? (
                    <img
                      src={getYoutubeThumbnailUrl(videoUrl)}
                      alt="ytVideo"
                      style={{
                        height: "31px",
                        width: "44px",
                        objectFit: "cover",
                      }}
                    />
                  ) : (
                    <video
                      width="44"
                      height="31"
                      preload="metadata"
                      style={{ objectFit: "cover" }}
                    >
                      <source src={videoUrl} type="video/mp4" />
                    </video>
                  )}
                </div>
              ))
            ) : (
              <div style={{ fontSize: "8px", fontFamily: "DM Sans" }}>
                Not found
              </div>
            )}
          </Carousel>

          <div style={{ paddingTop: "5px" }}>
            <Typography
              variant="subtitle1"
              component="subtitle1"
              style={{
                fontFamily: "DM Sans",
                fontWeight: "500",
                fontSize: "10px",
              }}
            >
              Audios
            </Typography>
          </div>

          <Carousel
            customLeftArrow={<CustomLeftArrow />}
            customRightArrow={<CustomRightArrow />}
            responsive={{
              superLargeDesktop: {
                breakpoint: { max: 4000, min: 3000 },
                items: 3,
              },
              desktop: { breakpoint: { max: 3000, min: 1024 }, items: 4 },
            }}
          >
            {audios?.length > 0 ? (
              audios.map((audio) => (
                <div
                  onClick={() => handleOpenPreviewAudio(audio)}
                  style={{
                    cursor: "pointer",
                    marginLeft: "4px",
                    marginRight: "4px",
                  }}
                >
                  <img
                    style={{
                      width: "30px",
                      height: "30px",
                      borderRadius: "8px",
                    }}
                    src={ASSETS.mp3Icon}
                    alt="Audio Thumbnail"
                  />
                </div>
              ))
            ) : (
              <div style={{ fontSize: "8px", fontFamily: "DM Sans" }}>
                Not found
              </div>
            )}
          </Carousel>

          <div style={{ paddingTop: "5px" }}>
            <Typography
              variant="subtitle1"
              component="subtitle1"
              style={{
                fontFamily: "DM Sans",
                fontWeight: "500",
                fontSize: "10px",
              }}
            >
              Documents
            </Typography>
          </div>
          <Carousel
            customLeftArrow={<CustomLeftArrow />}
            customRightArrow={<CustomRightArrow />}
            responsive={{
              superLargeDesktop: {
                breakpoint: { max: 4000, min: 3000 },
                items: 3,
              },
              desktop: { breakpoint: { max: 3000, min: 1024 }, items: 4 },
            }}
          >
            {documents?.length > 0 ? (
              documents.map((doc) => (
                <div onClick={() => window.open(doc, "_blank")}>
                  <img
                    style={{
                      width: "30px",
                      height: "30px",
                      borderRadius: "8px",
                      cursor: "pointer",
                      marginLeft: "4px",
                      marginRight: "4px",
                    }}
                    src={ASSETS.pdfIcon}
                    alt="Document Thumbnail"
                  />
                </div>
              ))
            ) : (
              <div style={{ fontSize: "8px", fontFamily: "DM Sans" }}>
                Not found
              </div>
            )}
          </Carousel>

          <VideoPreviewModal
            openPreviewVideo={openPreviewVideo}
            handleClosePreviewVideo={handleClosePreviewVideo}
            videoUrl={selectedVideo}
          />
          <ImagePreviewModal
            openPreviewImage={openPreviewImage}
            handleClosePreviewImage={handleClosePreviewImage}
            selectedImage={selectedImage}
          />

          <AudioPreviewModal
            openPreviewAudio={openPreviewAudio}
            handleClosePreviewAudio={handleClosePreviewAudio}
            audioUrl={selectedAudio}
          />

          <YoutubeVideoPreviewModal
            openPreviewVideo={openYoutubePreviewVideo}
            handleClosePreviewVideo={handleClosePreviewYoutubeVideo}
            videoUrl={selectedYoutubeVideo}
          />
        </div>
      </div>
    </>
  );
};

export default RenderMedia;
